export default {
  ENTRANCE: 'Вхід в особистий кабінет',
  FORGOT: 'Забули пароль?',
  SEND: 'Надіслати',
  NO_ACCOUNT: 'Не маєте облікового запису?',
  REGISTRATION: ' Зареєструватися',
  ERROR: 'Не вiрнi авторизацiйнi даннi. Спробуйте будь-ласка ще раз',
};
